document.addEventListener("DOMContentLoaded", function () {
  const $ = window.jQuery;

  /* =========================================
     PDP TOOLTIP + BADGE INTERACTIONS (KEEP)
  ========================================== */
  const tooltipWrappers = document.querySelectorAll('.pdp-tooltip-wrapper');
  const imageWrapper = document.querySelector('.product__images');
  const badgeContainers = document.querySelectorAll('.product-badge-container');
  const badges = document.querySelectorAll('.product-badge');

  tooltipWrappers.forEach(wrapper => {
    const trigger = wrapper.querySelector('.pdp-tooltip-trigger');
    const bubble = wrapper.querySelector('.pdp-tooltip__bubble');
    const link = wrapper.querySelector('.pdp-tooltip__link');

    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (!wrapper.classList.contains('touch-active')) {
            e.preventDefault();
            tooltipWrappers.forEach(w => {
              if (w !== wrapper) w.classList.remove('touch-active');
            });
            wrapper.classList.add('touch-active');
          } else if (bubble && !bubble.contains(e.target) && link && !link.contains(e.target)) {
            wrapper.classList.remove('touch-active');
          }
        });
      }

      if (link) {
        link.addEventListener('click', function (e) {
          e.stopPropagation();
          wrapper.classList.remove('touch-active');
        });
      }

      document.addEventListener('click', function (e) {
        if (!wrapper.contains(e.target)) {
          wrapper.classList.remove('touch-active');
        }
      });
    }
  });

  badgeContainers.forEach(badge => {
    if (imageWrapper && badge) imageWrapper.appendChild(badge);
  });

  badges.forEach(function (badge) {
    badge.addEventListener('touchstart', function (e) {
      e.stopPropagation();
      badges.forEach(b => b.classList.remove('active'));
      badge.classList.toggle('active');
    });
  });

  document.addEventListener('touchstart', function (e) {
    if (![...badges].some(b => b.contains(e.target))) {
      badges.forEach(b => b.classList.remove('active'));
    }
  });

  /* =========================================
     PDP SLIDER – COMMON IMAGE BADGE (FIXED)
     - Works even if slick initializes AFTER DOMContentLoaded
  ========================================== */
  const sliderBadge = document.querySelector('.product-common-image-badge');
  const slider = document.querySelector('.js-product__gallery');

  function updateSliderBadge() {
    if (!sliderBadge || !slider) return;

    // Slick uses .slick-current. Fallbacks for other sliders.
    const currentSlide =
      slider.querySelector('.slick-current') ||
      slider.querySelector('.is-selected') ||
      slider.querySelector('.active');

    const isCommon = !!(currentSlide && currentSlide.querySelector('.gallery-item--common'));

    // Always hide unless current slide is common
    sliderBadge.hidden = !isCommon;
  }

  if (sliderBadge) sliderBadge.hidden = true;

  // Run once now + again shortly after (covers slick init timing)
  updateSliderBadge();
  setTimeout(updateSliderBadge, 150);
  setTimeout(updateSliderBadge, 600);

  // If slick exists, bind to its event (best case)
  if ($ && slider) {
    try {
      $(slider).on('afterChange', function () {
        updateSliderBadge();
      });
      $(slider).on('init', function () {
        updateSliderBadge();
      });
    } catch (e) {}
  }

  // Always keep a MutationObserver as a fallback
  if (slider) {
    const obs = new MutationObserver(updateSliderBadge);
    obs.observe(slider, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  /* =========================================
     FANCYBOX / LIGHTBOX – COMMON IMAGE BADGE (FIXED)
     - Only injects if the CLICKED trigger is a common image
     - Uses Fancybox v3 correct origin: slide.opts.$orig
  ========================================== */
  if ($ && $.fancybox) {
    $(document).off('afterShow.fb.floofCommonBadge'); // prevent duplicates if theme re-inits
    $(document).on('afterShow.fb.floofCommonBadge', function (e, instance, slide) {
      // remove any badge first
      $('.fancybox-slide--current .gallery-common-image-badge').remove();

      // Fancybox v3 origin element
      const $orig = slide && slide.opts && slide.opts.$orig ? slide.opts.$orig : null;
      if (!$orig || !$orig.length) return;

      // ONLY if the clicked item is a common image
      // (this requires data-common-image="true" on gallery-item-common links)
      if (!$orig.is('[data-common-image="true"]')) return;

      const badgeHtml = `
        <div class="gallery-common-image-badge">
          Comes with Exclusive Floof Dust Bag
        </div>
      `;

      $('.fancybox-slide--current').append(badgeHtml);
    });
  }
});
